<template>
  <div class="chat-container" ref="chatcontainer">
    <div class="modal-backdrop-my fade show" @click="clickOutside"></div>
    <div v-if="loading" class="pt-5 text-center">
      <base-spinner></base-spinner>
    </div>
    <message-display v-else :messages="messages" @load:messages="loadNewData"></message-display>

    <div class="send-message input-group" style="border-top: 1px solid #ccc">
      <input
        v-model="new_message.content"
        type="text"
        class="form-control"
        autocomplete="off"
        @keyup.enter="sendMessage"
        :placeholder="$t('src/components/chat.1203')"
        style="border: none"
      />
      <button type="button" class="btn btn-with-icon icon icon-send-message" @click="sendMessage"></button>
    </div>
  </div>
</template>

<script>
import moment from 'moment/src/moment'
import http from '@/modules/http.js'
import { subscribeMessages } from '@/mixins/subscribe-messages.js'
import { showInChat } from '@/events.config.js'
import { stringify } from 'qs'

import('@/styles/components/chat.less')

export default {
  name: 'ChatComponent',
  components: {
    MessageDisplay: () => import('@/components/MessageDisplay.vue'),
    BaseSpinner: () => import('@/base/BaseSpinner.vue')
  },
  mixins: [subscribeMessages],
  props: {
    activeChat: {
      type: Number,
      required: true
    },
    activeTrainings: {
      type: Array,
      required: false
    },
    isShow: {
      type: Boolean,
      require: true
    }
  },
  data: () => ({
    loading: true,
    messages: [],
    events: null,
    new_message: {
      course_id: null,
      content: null
    },
    total: null,
    limit: 30,
    offset: null,
    numberNewMessages: 20
  }),
  watch: {
    isShow() {
      if (this.isShow) this.updateScroll()
    }
  },
  created() {
    this.loadData(0, 0).then(data => {
      this.canSubscribe = true
      this.new_message.course_id = this.activeChat
      this.total = data.total
      this.offset = this.total <= this.limit ? 0 : this.total - this.limit
      this.loadData(this.limit, this.offset)
        .then(data => {
          this.messages = data.data
        })
        .then(() => {
          if (this.activeTrainings && this.activeTrainings.length != 0) this.loadEvents()
        })
        .then(() => (this.loading = false))
    })
    window.addEventListener('resize', this.setPosition)
  },
  updated() {
    this.setPosition()
  },
  beforeDestroy() {
    let messUpdated = this.messages.filter(item => {
      return item.isRead && item.id
    })
    if (messUpdated.length > 0) {
      let messUpdatedIds = messUpdated.map(item => {
        return item.id
      })
      this.updateMessage(Array.from(messUpdatedIds))
    }
  },
  methods: {
    clickOutside(e) {
      if (e.target.closest('.chat-container') === this.$refs.chatcontainer) {
        this.$emit('close:chat')
      }
    },
    getFormattedDate(date) {
      moment.locale('ru')
      return moment(date).format('HH:mm, DD.MM.YY')
    },
    getCreatedDate(date) {
      return this.moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    updateScroll() {
      var element = document.getElementById('chat-messages')
      if (element) {
        element.scrollTop = element.scrollHeight
      }
    },
    changeChatEvent(data) {
      if (this.isShow) data.isRead = true
      this.messages.push(data)
      this.messages.sort((a, b) => (new Date(a.createdAt) > new Date(b.createdAt) ? 1 : -1))
      setTimeout(() => {
        this.updateScroll()
      }, 100)
      this.$emit('change:haveNewMessage')
      return true
    },
    loadData(limit, offset) {
      return new Promise(resolve => {
        http
          .get('/messages', {
            params: {
              course_id: this.activeChat,
              deleted: 0,
              $limit: limit,
              $skip: offset
            }
          })
          .then(response => response.data)
          .then(data => {
            resolve(data)
          })
          .catch(error => console.error(error))
        //.finally(() => (this.loading = false))
      })
    },
    addEvent(data) {
      let training = this.activeTrainings.find(tr => tr.id === data.tr_id)
      let date = new Date(training.date_start)
      date.setSeconds(date.getSeconds() + +data.time)
      let mess = {
        content: data.value,
        isFromSession: true,
        createdAt: this.getCreatedDate(date)
      }
      switch (data.episodeType) {
        case 'eventText':
          mess.type = 2
          break
        case 'eventBP':
          mess.type = 4
          break
        case 'eventSpO2':
          mess.type = 3
      }
      this.changeChatEvent(mess)
    },
    loadEvents() {
      this.activeTrainings.forEach(tr => {
        http
          .get('/ongoing-training/' + tr.id, {
            params: {
              type: 'ce'
            }
          })
          .then(response => {
            response.data.data.forEach(ev => {
              if (showInChat.includes(ev.episodeType)) {
                let data = {}
                data.content = ev.value
                data.isFromSession = true
                let date = new Date(tr.date_start)
                date.setSeconds(date.getSeconds() + +ev.time)
                data.createdAt = this.getCreatedDate(date)
                switch (ev.episodeType) {
                  case 'eventText':
                    data.type = 2
                    break
                  case 'eventBP':
                    data.type = 4
                    break
                  case 'eventSpO2':
                    data.type = 3
                }
                this.changeChatEvent(data)
              }
            })
          })
      })
    },
    async sendMessage() {
      if (this.new_message.content) {
        await http
          .post('/messages', this.new_message)
          .then(response => response.data)
          .then(data => {
            this.new_message = data
          })
      }
      this.new_message.content = ''
    },
    updateMessage(ids) {
      http.patch(
        '/messages/',
        { is_read: 1 },
        {
          params: {
            course_id: this.activeChat,
            id: { $in: ids }
          },
          paramsSerializer: params =>
            stringify(params, {
              arrayFormat: 'indices',
              encodeValuesOnly: true
            })
        }
      )
    },
    loadNewData() {
      var element = document.getElementById('chat-messages')
      if (this.offset >= this.numberNewMessages) {
        this.offset = this.offset - this.numberNewMessages
        this.loadData(this.numberNewMessages, this.offset).then(data => {
          this.messages.unshift(...data.data)
        })
        element.scrollTop = this.numberNewMessages
      } else if (this.offset > 0) {
        this.loadData(this.offset, 0).then(data => {
          this.messages.unshift(...data.data)
        })
        this.offset = 0
        element.scrollTop = this.numberNewMessages
      }
    },
    setPosition() {
      this.$el.style.top = `${this.$parent.$el.offsetTop + this.$parent.$el.children[0].clientHeight}px`
      this.$el.style.right = `${this.$parent.$parent.$el.offsetParent.clientWidth -
        this.$parent.$el.offsetWidth -
        this.$parent.$el.offsetLeft}px`
    }
  }
}
</script>
